var util = require('../../app/util');
var ajax = require('@enhancer/fe-util-ajax');
var pageConfig = window.pageConfig;
var loading = false;
module.exports = function doAjax (action, data, cb) {
  if (loading) {
    return 
  }
  loading = true;
  
  var url = `${pageConfig.projectName}/topic/${data.tid ?  data.tid + '/' : ''}`;
  url =  data.cid ? `${url}/${data.cid}/${action}` : url + action;

  var plate = location.pathname.match(/^\/plate\/([^/]+)/);
  plate = plate ? plate[1] : pageConfig.defaultPlate;
  data.plate = data.plate || plate;
  
  ajax({
    type: 'POST',
    contentType: "application/json",
    url: url,
    data: JSON.stringify(data)
  }, function (res) {
    if (res.success) {
      cb(res);
    } else {
      util.show(res.message);
    }
    setTimeout(function() {
      loading = false
    }, 1000)
  }, function () {
    util.show('load error');
    loading = false
  });
}


// WEBPACK FOOTER //
// ./src/pages/topic/ajax.js